import { moveBackdrop } from "../../utilities/animate-backdrop.js";
import { getLangDir } from "../../utilities/get-language-direction.js";
const selectTab = ({ enableTransitions, onChange, tabList, target }) => {
  const tabs = Array.from(tabList?.querySelectorAll(".tds-tab"));
  const oldSelectedTab = tabs.find((tab) => {
    return tab.getAttribute("aria-selected") === "true" || tab.classList.contains("tds-tab--active");
  });
  if (oldSelectedTab) {
    oldSelectedTab.setAttribute("aria-selected", "false");
    oldSelectedTab.classList.remove("tds-tab--active");
    oldSelectedTab.setAttribute("tabindex", "-1");
  }
  target.classList.add("tds-tab--active");
  target.setAttribute("aria-selected", "true");
  target.setAttribute("tabindex", "0");
  moveBackdrop(tabList, target, enableTransitions);
  if (onChange)
    onChange(target);
  return target;
};
const selectTabSibling = (tab, siblingKey) => {
  const target = tab[siblingKey];
  if (target) {
    target.focus();
  }
};
const handleKeyPress = (e) => {
  const { key, target } = e;
  const dir = target ? getLangDir(target) : "ltr";
  if (dir === "rtl" && key === "ArrowLeft" || dir === "ltr" && key === "ArrowRight" || key === "ArrowDown") {
    e.preventDefault();
    selectTabSibling(target, "nextElementSibling");
  }
  if (dir === "rtl" && key === "ArrowRight" || dir === "ltr" && key === "ArrowLeft" || key === "ArrowUp") {
    e.preventDefault();
    selectTabSibling(target, "previousElementSibling");
  }
};
const selectPanel = ({ target }) => {
  const targetPanel = document.getElementById(target.getAttribute("aria-controls") || "");
  if (!targetPanel) {
    return;
  }
  const panels = Array.from(targetPanel?.parentElement?.querySelectorAll(".tds-tab-panel") || []);
  panels.forEach((panel) => {
    panel.classList.remove("tds-tab-panel--active");
    panel.removeAttribute("tabindex");
  });
  targetPanel.classList.add("tds-tab-panel--active");
  targetPanel.setAttribute("tabindex", "0");
};
const initTabList = (tabList, props = {}) => {
  const { onTabChange } = props;
  const tabs = Array.from(tabList?.querySelectorAll(".tds-tab"));
  let selectedTab = tabs.find((tab) => {
    return tab.getAttribute("aria-selected") === "true" || tab.classList.contains("tds-tab--active");
  }) || tabs[0];
  window.requestAnimationFrame(() => {
    selectedTab = selectTab({
      enableTransitions: false,
      onChange: onTabChange,
      tabList,
      target: selectedTab
    });
  });
  window.addEventListener("resize", () => {
    selectedTab = selectTab({
      enableTransitions: true,
      onChange: onTabChange,
      tabList,
      target: selectedTab
    });
  });
  tabs.forEach((tab) => {
    const handleSelect = (e) => {
      const target = e.target;
      const tab2 = target?.localName === "button" ? target : target?.closest("button.tds-tab");
      selectedTab = selectTab({
        enableTransitions: true,
        onChange: onTabChange,
        tabList,
        target: tab2 || target
      });
      selectPanel({ target: selectedTab });
    };
    tab.addEventListener("click", handleSelect);
    tab.addEventListener("focus", handleSelect);
    tab.addEventListener("keydown", handleKeyPress);
  });
};
const initTabLists = (props = {}) => {
  const { parent = document } = props;
  const tabLists = Array.from(parent.querySelectorAll(".tds-tab-list"));
  tabLists.forEach((component) => {
    initTabList(component, props);
  });
};
export {
  initTabList,
  initTabLists,
  selectPanel,
  selectTab
};
